import {
  Chart as ChartJS,
  Title,
  Tooltip,
  LineElement,
  LinearScale,
  CategoryScale,
  PointElement,
  Filler
} from 'chart.js'

import ChartDataLabels from 'chartjs-plugin-datalabels'

function init () {
  ChartJS.register(
    Title,
    Tooltip,
    LineElement,
    LinearScale,
    CategoryScale,
    PointElement,
    Filler,
    ChartDataLabels
  )
}

export default {
  ...ChartJS,
  init
}
